/* eslint-disable react-hooks/exhaustive-deps */
import CreateIcon from "@mui/icons-material/Create";
import ClearIcon from "@mui/icons-material/Clear";
import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SET_REPORT_OBSERVATION_PROTOCOL,
  SHOW_MODAL,
  REMOVE_REPORT_OBSERVATION_PROTOCOL,
} from "../../../../../store/actions";
import { isEmptyHtml } from "../../../../shared/helpers";

export function ProtocolEditable({
  children,
  ri,
  protocolIndex,
  ml = "20000",
}) {
  const dispatch = useDispatch();

  // Get the protocol value from Redux
  const protocolValue = useSelector((state) => {
    if (ri === undefined || protocolIndex === undefined) {
      return undefined;
    }
    return state.report?.observations?.data?.[ri]?.protocol_text?.[
      protocolIndex
    ];
  });

  const resolvedValue = protocolValue ?? children ?? "";

  // Handler to update protocol in Redux
  const updateProtocol = useCallback(
    (text) => {
      const valueToPersist = text ?? "";

      dispatch({
        type: SET_REPORT_OBSERVATION_PROTOCOL,
        payload: {
          path: "protocol",
          data: valueToPersist,
          roomIndex: ri,
          protocolIndex,
        },
      });
    },
    [dispatch, ri, protocolIndex]
  );

  // Handler to open the modal
  const openModal = useCallback(() => {
    const initialValue = resolvedValue ?? "";

    dispatch({
      type: SHOW_MODAL,
      payload: {
        show: true,
        value: initialValue,
        setValue: updateProtocol,
        ml: ml,
        richText: true,
        roomIndex: ri,
        customEditorType: "protocol",
      },
    });
  }, [dispatch, resolvedValue, ml, ri, updateProtocol]);

  // Handler to remove protocol
  const removeProtocol = useCallback(() => {
    dispatch({
      type: REMOVE_REPORT_OBSERVATION_PROTOCOL,
      payload: {
        path: "protocol",
        roomIndex: ri,
        protocolIndex,
      },
    });
  }, [dispatch, ri, protocolIndex]);

  return (
    <div className="editable-text">
      <div className="tools pen">
        <CreateIcon color="#2f481e" onClick={openModal} />
      </div>

      <span
        dangerouslySetInnerHTML={{
          __html: !isEmptyHtml(children) ? children : "Click to add text",
        }}
        className="no-margin"
        onClick={openModal}
      ></span>

      <div className="tools cross">
        <ClearIcon color="#b44a4a" onClick={removeProtocol} />
      </div>
    </div>
  );
}
